



























































































































































import { Vue, Component, Prop, PropSync, Ref } from 'vue-property-decorator'
import colors from 'src/assets/colors'
import ModalDialog from 'components/modals/Dialog.vue'
import confirm from 'components/modals/Confirm'
import { select as selectMinutes } from 'components/modals/Timer.vue'
import MenuButtonAdd from 'components/presenter/item/topic/MenuButtonAdd.vue'
import api from 'src/assets/api/gql'
import ItemAttachmentDelete from 'src/graphql/item/ItemAttachmentDelete.gql'
import { Item, ItemTypeTopic } from 'src/graphql/types'

@Component({
  components: {
    ModalDialog,
    MenuButtonAdd
  }
})
export default class ItemTopicSlidesEditorMenu extends Vue {
  ItemTypeTopic = ItemTypeTopic
  colors = colors

  @Prop()
  readonly item!: Item

  @Prop()
  readonly slides!: Json[]

  @Prop()
  readonly gridSlides!: Json[]

  @Prop()
  readonly corrects!: Json

  @Prop()
  readonly save!: (slides: Json[], name: string, value: any) => void

  @PropSync('reorderSync')
  reorder!: boolean

  @PropSync('selectedSync')
  selected!: Set<Json> | null

  @Ref()
  readonly setSlideGroupDialog!: ModalDialog

  toggleSelectMode () {
    this.selected = this.selected === null ? new Set() : null
    this.reorder = false
  }

  toggleReorderMode () {
    this.reorder = !this.reorder
    this.selected = null
  }

  async setSlideTimer () {
    const selected = [...(this.selected || [])]
    const selectedSlides = selected.filter(s => !s.meta?.masterSlide)
    const selectedPages = selected.filter(s => s.meta?.masterSlide)
    const slidetimer = selected.length ? selected[0].timer : 0
    const timer = await selectMinutes(this, {
      title: this.$t('slides.timer').toString(),
      value: slidetimer,
      minutes: true,
      seconds: true
    })
    await this.save(selectedSlides, 'timer', timer)
    await this.setPagesMeta(selectedPages, 'timer', timer)
  }

  async toggleSlideShuffle () {
    const selected = [...(this.selected || [])]
    const selectedSlides = selected.filter(s => !s.meta?.masterSlide)
    const selectedPages = selected.filter(s => s.meta?.masterSlide)
    const shuffle = selected.length ? selected[0].shuffle || false : false
    await this.save(selectedSlides, 'shuffle', !shuffle)
    await this.setPagesMeta(selectedPages, 'shuffle', !shuffle)
  }

  async toggleSlideHide () {
    const selected = [...(this.selected || [])]
    const selectedSlides = selected.filter(s => !s.meta?.masterSlide)
    const selectedPages = selected.filter(s => s.meta?.masterSlide)
    const hide = selected.length ? selected[0].hide || false : false
    await this.save(selectedSlides, 'hide', !hide)
    await this.setPagesMeta(selectedPages, 'hide', !hide)
  }

  async setSlideGroup (name: string | null) {
    this.setSlideGroupDialog.hide()
    const selected = [...(this.selected || [])]
    const selectedSlides = selected.filter(s => !s.meta?.masterSlide)
    const selectedPages = selected.filter(s => s.meta?.masterSlide)
    await this.save(selectedSlides, 'group', name)
    await this.setPagesMeta(selectedPages, 'group', name)
  }

  async deleteSlides () {
    await confirm({
      title: this.$t('label.deleteConfirm').toString(),
      message: this.$t('slides.edit.delete').toString(),
      btnRight: this.$t('label.delete').toString(),
      btnRightColor: 'warning'
    })
    const selected = [...(this.selected || [])]
    const selectedSlides = selected.filter(s => !s.meta?.masterSlide)
    const selectedPages = selected.filter(s => s.meta?.masterSlide)
    // console.log(selected)
    // console.log(selectedSlides)
    // console.log(selectedPages)
    await this.save(selectedSlides, 'deleted', new Date().getTime())
    const masterSlides = await this.setPagesMeta(selectedPages, 'deleted', new Date().getTime())
    // console.log(masterSlides)
    await this.deleteEmptyMasterSlides(masterSlides)
  }

  async deleteEmptyMasterSlides (masterSlides: Set<Json>) {
    const empty = []
    for (const masterSlide of masterSlides) {
      const pages = (masterSlide.meta?.pages || []).reduce((pages: Json[], page: Json) => page.deleted ? pages : [...pages, page], [])
      if (pages.length === 0) {
        empty.push(masterSlide)
      }
    }
    // console.log(empty)
    await this.save(empty, 'meta', null)
    await this.save(empty, 'deleted', new Date().getTime())
  }

  async setPagesMeta (pages: Json[], name: string, value: any) {
    for (const page of pages) {
      page.meta.masterSlide.meta.pages[ page.meta.masterSlidePageIndex ][ name ] = value
      // console.log(page.meta.masterSlide.meta.pages[ page.meta.masterSlidePageIndex ])
    }
    const masterSlides = new Set<Json>(pages.map(s => s.meta?.masterSlide))
    for (const masterSlide of masterSlides) {
      await this.save([ masterSlide ], 'meta', masterSlide.meta)
    }
    return masterSlides
  }

  copySlides () {
    const selected = [...(this.selected || [])].filter(s => !s.meta?.masterSlide)
    for (const slide of selected) {
      const paramSlides = new Set<Json>()
      if (slide.params) {
        const params = this.slides.find(x => x.id === slide.params)
        if (params) {
          paramSlides.add(params)
        }
      }
      selected.push(...paramSlides)
    }
    const pageSlides = [...(this.selected || [])].filter(s => s.meta?.masterSlide)
    for (const pageSlide of pageSlides) {
      const slide = Object.assign({}, pageSlide.meta.masterSlide, { meta: null, pageNo: pageSlide.pageNo })
      selected.push(slide)
    }
    const clipboard = (this.$q.localStorage.getItem('SlideClipboard') || []) as Json[]
    clipboard.unshift({
      topicName: this.item.name,
      courseName: this.item.courseId ? this.item.parent?.name : undefined,
      slides: selected.map(slide => Object.assign(slide, { correct: this.corrects[ slide.id ] }))
    })
    this.$q.localStorage.set('SlideClipboard', clipboard.slice(0, 5))
    this.$q.notify({
      message: this.$t('slides.edit.copy').toString(),
      color: 'info'
    })
  }
}
